import React, {useState} from 'react';
import {withStyles} from "@material-ui/core";
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import BuildingDetails from '../../components/Building/BuildingDetails';
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";


const BuildingShow = ({building, routeToIndex, classes}) => {

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    let items = [{
            icon: 'arrow_back_ios',
            text: i18n.get('default.nav.back'),
            href: building.parent ? `/construction/${building.parent.id}` : routeToIndex,
            color: 'secondary',
            size: 'small',
        }
    ];

    window.can('buildings.create') && items.push( {
        icon: 'edit',
        text: i18n.get(building.parent ? 'building.edit_house' : 'building.edit'),
        href: `/construction/${building.id}/edit`,
        size: 'small',
        color: 'primary',
    } );

    /*{
        icon: 'history',
        text: i18n.get('project.history.button'),
        href: `/building/${project.id}/history`,
    },*/

    /*{
        icon: 'description',
        text: i18n.get('building.make_pdf'),
        //href: `/construction/${building.id}/edit`,
        size: 'small',
        onClick: handleClickOpen,
    }*/

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={building.name || (building.city + ', ' + building.street + ' ' + building.number) }
                items={items}
            />

            <BuildingDetails building={building} />

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="form-dialog-title" className={classes.dialogTitle} disableTypography>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose} size={'small'}>
                        <Icon>close</Icon>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className={classes.dialogContent}>
                    {'Dieser Button hat leider noch keine Funktion!'}
                </DialogContent>
            </Dialog>
        </Layout>
    );
}
const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
        height:72,
    },
    dialogContent: {
        overflow:'visible',
        paddingTop: 10,
    },
    dialogActions: {
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
        //color: theme.palette.grey[500],
    },
});

export default withStyles(styles)(BuildingShow);

